import { Location } from '@angular/common';
import { AppService } from '../../shared/services/app.service';
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import {
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalService
} from '@azure/msal-angular';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OfflineMsalInterceptor extends MsalInterceptor {
  constructor(
    @Inject(MSAL_INTERCEPTOR_CONFIG)
    msalInterceptorConfig: MsalInterceptorConfiguration,
    authService: MsalService,
    location: Location,
    msalBroadcastService: MsalBroadcastService,
    private appService: AppService,
    @Inject(DOCUMENT) document?: Document
  ) {
    super(
      msalInterceptorConfig,
      authService,
      location,
      msalBroadcastService,
      document
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.appService.isOnline()) {
      //console.info('MSAL Interceptor - offline mode.');
      return next.handle(req);
    }
    //console.info('MSAL Interceptor - online mode.');
    return super.intercept(req, next);
  }

  // override intercept(
  //   req: HttpRequest<HTTP_REQUEST_METHODS>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<HTTP_REQUEST_METHODS>> {
  //   if (!this.appService.isOnline()) {
  //     //console.info('MSAL Interceptor - offline mode.');
  //     return next.handle(req);
  //   }
  //   //console.info('MSAL Interceptor - online mode.');
  //   return super.intercept(req, next);
  // }
}
